import React from "react";
import { observer } from "mobx-react";
import { WeaInputSearch } from "ecCom";

@observer
export default class InputSearchItem extends React.PureComponent {
  onChange = (...args) => {
    const { bindObj, itemKey, onChange } = this.props;
    bindObj.onChange(...args);
    if (typeof onChange === "function") {
      onChange(itemKey, args);
    }
  };
  onBlur = value => {
    const { itemKey, onBlur } = this.props;
    if (typeof onBlur === "function") {
      onBlur(itemKey, value);
    }
  };
  onSearch = (...args) => {
    const { itemKey, onSearch } = this.props;
    if (typeof onSearch === "function") {
      onSearch(itemKey, ...args);
    }
  };
  render() {
    const { bindObj, c } = this.props;
    return (
      <WeaInputSearch
        {...bindObj.bind()}
        value={toJS(bindObj.value)}
        onSearch={this.onSearch}
        onChange={this.onChange}
        onBlur={this.onBlur}
        {...c}
        {...c.otherParams}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./comMobx/wea-switch/components/InputSearchItem.js